/**
 * v3.21-1707 — PhoneSystemAdminRoute
 * Wraps /phone-system routes.  Allows only ptc_admin / ptc_director.
 * All other authenticated callers redirect to /smart-dialer if they
 * are internal (regular team) or back to /clients otherwise.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PHONE_SYSTEM_ADMIN_ROLES = ['ptc_admin', 'ptc_director'];

export default function PhoneSystemAdminRoute({ children }) {
  const { user, isInternal } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const role = (user.role || '').toLowerCase();
  if (PHONE_SYSTEM_ADMIN_ROLES.includes(role)) return children;
  if (typeof isInternal === 'function' && isInternal()) {
    return <Navigate to="/smart-dialer" replace />;
  }
  return <Navigate to="/clients" replace />;
}

export function SmartDialerRoute({ children }) {
  const { user, isInternal } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (typeof isInternal === 'function' && isInternal()) return children;
  return <Navigate to="/clients" replace />;
}
